import React from 'react';

export function PageHeader({ title, description, children }) {
  return <header className="page-header">
    <div><h1 className="page-title">{title}</h1>{description && <p className="page-description">{description}</p>}</div>
    {children && <div className="page-actions">{children}</div>}
  </header>;
}

export function DateTime({ value }) {
  if (!value) return <span aria-label="Not available">—</span>;
  const date = new Date(value?.toDate ? value.toDate() : value);
  if (Number.isNaN(date.getTime())) return <span aria-label="Not available">—</span>;
  const datePart = new Intl.DateTimeFormat(undefined, { day: '2-digit', month: 'short', year: 'numeric' }).format(date);
  const timePart = new Intl.DateTimeFormat(undefined, { hour: '2-digit', minute: '2-digit' }).format(date);
  return <time className="date-time" dateTime={date.toISOString()}><span>{datePart}</span><span className="text-xs text-gray-400">{timePart}</span></time>;
}

export function AccountBadge({ kind, children }) {
  const styles = {
    active: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
    approved: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
    verified: 'bg-sky-50 text-sky-700 ring-sky-200',
    pending: 'bg-amber-50 text-amber-800 ring-amber-200',
    rejected: 'bg-red-50 text-red-700 ring-red-200',
    disabled: 'bg-gray-100 text-gray-600 ring-gray-200',
    unverified: 'bg-orange-50 text-orange-700 ring-orange-200',
    client: 'bg-purple-50 text-primary ring-purple-200',
    worker: 'bg-lime-50 text-lime-800 ring-lime-200',
    // "Hesabı sil" (Delete Account) lifecycle -- deliberately distinct from
    // plain "disabled" so an admin can tell an admin-initiated disable apart
    // from an in-progress or completed account deletion at a glance.
    deletion: 'bg-red-50 text-red-700 ring-red-200',
  };
  return <span className={`badge ring-1 ring-inset ${styles[kind] || styles.disabled}`}>{children}</span>;
}
